module.exports = __webpack_public_path__ + "img/shou.3072df18.png";